import React, { Context, createContext, Dispatch, FC, ReactNode, SetStateAction, useState } from "react";

interface IProps {
  children: ReactNode;
}

export const CustomModalContext: Context<any> = createContext({});

/**
 * This Provider manages the physics/behaviour of the modal it encloses
 * i.e - when to open or close
 * @param children
 * @constructor
 */
export const CustomModalProvider: FC<IProps> = ({ children }: IProps) => {
  const [showModal, setShowModal]: [boolean, Dispatch<SetStateAction<any>>] = useState(false);

  return (
    <CustomModalContext.Provider value={{ showModal, setShowModal }}>
      {children}
    </CustomModalContext.Provider>
  );
};
